// extracted by mini-css-extract-plugin
export var editButtonTitle = "partenaires-module--edit-button-title--47ac5";
export var listPartenairesContainer = "partenaires-module--list-partenaires-container--2771c";
export var partenaireDescription = "partenaires-module--partenaire-description--c1b97";
export var partenaireItemDescription = "partenaires-module--partenaire-item-description--0dd18";
export var partenairesContainer = "partenaires-module--partenaires-container--ba85b";
export var partenairesTitle = "partenaires-module--partenaires-title--73104";